<style lang="scss" src='./ProvisioningStep4.scss' scoped ></style>
<template src="./ProvisioningStep4.html"></template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'ProvisioningStep4',
  data() {
    return ({
      sensor: null,
    });
  },
  computed: {},

  methods: {
    ...mapMutations('SensorProvisioning', ['setCanBack', 'setCanContinue']),
  },

  beforeCreate() {},

  created() {},

  activated() {
    this.setCanContinue(null);
    this.setCanBack(null);
  },

  mounted() {
    this.sensor = this.$store.state.sensor;
  },
};
</script>
